import { StyleSheet } from 'aphrodite/no-important';

let styles = {
  actions: {
    display: 'flex',
    flexShrink: 0,
    marginTop: 'auto',
    justifyContent: 'flex-end',
    boxSizing: 'border-box',
    padding: '20px 0 0',
    width: '100%',
    ':nth-child(1n) *': {
      marginLeft: 3
    }
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/components/forms/formactions/FormActions.styles.js